import { FC } from 'react'

import styles from './AmplifyTrack.module.scss'

interface IAmplifyTrackProps {
  value: string
}

export const AmplifyTrack: FC<IAmplifyTrackProps> = ({ value }) => {
  if (value === 'Power Elite') {
    const [first, second] = value.split(' ')

    return (
      <div className={styles.root}>
        <div className={styles.first}>{first}</div>
        <div className={styles.second}>{second}</div>
      </div>
    )
  }

  if (!value) {
    return null
  }

  return (
    <div className={styles.root}>
      <div className={styles.first}>{value}</div>
    </div>
  )
}
